import { render, staticRenderFns } from "./CTSHeader.vue?vue&type=template&id=27a0dd84"
import script from "./CTSHeader.vue?vue&type=script&lang=js"
export * from "./CTSHeader.vue?vue&type=script&lang=js"
import style0 from "./CTSHeader.vue?vue&type=style&index=0&id=27a0dd84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports